import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactPaginate from "react-paginate";
import EventsSearchContext from "../../../application/Context/EventsSearchContext";
import { useContext } from "react";
export var Pagination = function () {
    var _a = useContext(EventsSearchContext), handlePageClick = _a.handlePageClick, pageCount = _a.pageCount, page = _a.page, view = _a.view;
    React.useEffect(function () { }, []);
    return (_jsx(React.Fragment, { children: pageCount > 1 && view == "list" &&
            _jsx(ReactPaginate, { previousLabel: "<", nextLabel: ">", breakLabel: "...", breakClassName: "break-me", pageCount: pageCount, marginPagesDisplayed: 2, pageRangeDisplayed: 5, onPageChange: handlePageClick, containerClassName: "pagination", subContainerClassName: "pages pagination", activeClassName: "active", forcePage: page }) }));
};
